import Image from "next/image";
import { FC } from "react";
import getConfig from "next/config";

const { publicRuntimeConfig } = getConfig();

const Header: FC = () => {
  return (
    <section className="relative">
      <div className="relative max-w-md">
        <h1 className="text-4xl font-bold md:text-5xl xl:text-6xl">
          Let&lsquo;s <span className="text-landing-orange">talk</span>
        </h1>
        <h2 className="mt-4 text-base">
          Want to know more about Keyzy&apos;s zero deposit, rent to buy solution? Ask us anything
          or just say hi.
        </h2>
      </div>

      <ul className="mt-12">
        <li className="flex items-center mb-6 font-serif text-2xl font-thin">
          <a
            href="mailto:hello@keyzy.com"
            target="_blank"
            rel="noreferrer"
            className="flex items-center"
          >
            <Image src="/contact/envelop.svg" alt="email" priority width={22} height={15} />
            <p className="ml-5 underline">hello@keyzy.com </p>
          </a>
        </li>

        {publicRuntimeConfig.FEATURE_HOLIDAYS_DISRUPTIONS !== "1" && (
          <>
            <li className="flex items-center font-serif text-2xl">
              <a
                href="https://wa.me/447707053999"
                target="_blank"
                rel="noreferrer"
                className="flex items-center"
              >
                <Image
                  src="/contact/whatsapp-cherry.svg"
                  alt="Contact us on WhatsApp"
                  priority
                  width={24}
                  height={24}
                />
                <p className="ml-5 underline">Chat with us on WhatsApp</p>
              </a>
            </li>
          </>
        )}
      </ul>
    </section>
  );
};

export default Header;
